export const APP_NAME = 'Custolink'
export const REDIRECT_URL_KEY = 'redirect'
